import { useState, useEffect, useCallback } from "react";
import { api } from "./api";

/* ─── ESTILOS GLOBALES ─────────────────────────────────────────────────────── */
const STYLE = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --bg:#0b0f1a;--surface:#111827;--surface2:#1a2236;--border:#1f2d45;
  --accent:#0ea5e9;--accent2:#38bdf8;--green:#22c55e;--yellow:#f59e0b;
  --red:#ef4444;--text:#e2e8f0;--muted:#64748b;
  --font:'Sora',sans-serif;--mono:'JetBrains Mono',monospace;
}
body{background:var(--bg);color:var(--text);font-family:var(--font)}
.app{display:flex;min-height:100vh}
.sidebar{width:220px;min-height:100vh;background:var(--surface);border-right:1px solid var(--border);display:flex;flex-direction:column;position:fixed;top:0;left:0;z-index:50}
.sidebar-logo{padding:24px 20px 20px;border-bottom:1px solid var(--border);font-size:13px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--accent);display:flex;align-items:center;gap:10px}
.sidebar-logo svg{width:22px;height:22px}
.sidebar-nav{padding:16px 10px;flex:1}
.nav-item{display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:8px;cursor:pointer;font-size:13.5px;font-weight:500;color:var(--muted);transition:all .18s;margin-bottom:2px}
.nav-item:hover{background:var(--surface2);color:var(--text)}
.nav-item.active{background:rgba(14,165,233,.13);color:var(--accent)}
.nav-item svg{width:16px;height:16px;flex-shrink:0}
.sidebar-footer{padding:16px 12px;border-top:1px solid var(--border);font-size:11px;color:var(--muted);font-family:var(--mono)}
.main{margin-left:220px;flex:1;display:flex;flex-direction:column}
.topbar{padding:18px 28px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;background:var(--surface);position:sticky;top:0;z-index:40}
.topbar-title{font-size:16px;font-weight:600}
.topbar-sub{font-size:12px;color:var(--muted);margin-top:2px}
.content{padding:28px;flex:1}
.card{background:var(--surface);border:1px solid var(--border);border-radius:12px;padding:22px 24px}
.card-title{font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:.08em;color:var(--muted);margin-bottom:16px}
.grid-2{display:grid;grid-template-columns:1fr 1fr;gap:18px}
.grid-3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:18px}
.grid-4{display:grid;grid-template-columns:repeat(4,1fr);gap:18px}
.stat-card{background:var(--surface);border:1px solid var(--border);border-radius:12px;padding:20px 22px}
.stat-label{font-size:11.5px;color:var(--muted);font-weight:500;text-transform:uppercase;letter-spacing:.07em}
.stat-value{font-size:26px;font-weight:700;margin-top:6px;font-family:var(--mono)}
.stat-badge{display:inline-block;margin-top:8px;padding:2px 8px;border-radius:20px;font-size:11px;font-weight:600}
.badge-green{background:rgba(34,197,94,.12);color:var(--green)}
.badge-yellow{background:rgba(245,158,11,.12);color:var(--yellow)}
.badge-blue{background:rgba(14,165,233,.12);color:var(--accent)}
.badge-red{background:rgba(239,68,68,.12);color:var(--red)}
.form-group{margin-bottom:16px}
.form-label{display:block;font-size:12px;font-weight:600;color:var(--muted);margin-bottom:6px;text-transform:uppercase;letter-spacing:.06em}
.form-input,.form-select,.form-textarea{width:100%;background:var(--bg);border:1px solid var(--border);border-radius:8px;padding:10px 14px;color:var(--text);font-family:var(--font);font-size:13.5px;transition:border-color .15s;outline:none}
.form-input:focus,.form-select:focus,.form-textarea:focus{border-color:var(--accent);box-shadow:0 0 0 3px rgba(14,165,233,.1)}
.form-select option{background:var(--surface)}
.form-textarea{resize:vertical;min-height:80px}
.btn{display:inline-flex;align-items:center;gap:7px;padding:9px 18px;border-radius:8px;border:none;cursor:pointer;font-family:var(--font);font-size:13.5px;font-weight:600;transition:all .16s;white-space:nowrap}
.btn:disabled{opacity:.5;cursor:not-allowed}
.btn-primary{background:var(--accent);color:#fff}
.btn-primary:hover:not(:disabled){background:var(--accent2);transform:translateY(-1px)}
.btn-secondary{background:var(--surface2);color:var(--text);border:1px solid var(--border)}
.btn-secondary:hover:not(:disabled){background:var(--border)}
.btn-danger{background:rgba(239,68,68,.15);color:var(--red);border:1px solid rgba(239,68,68,.25)}
.btn-danger:hover:not(:disabled){background:rgba(239,68,68,.25)}
.btn-success{background:rgba(34,197,94,.15);color:var(--green);border:1px solid rgba(34,197,94,.25)}
.btn-sm{padding:6px 12px;font-size:12px}
.btn svg{width:15px;height:15px}
.table-wrap{overflow-x:auto}
table{width:100%;border-collapse:collapse;font-size:13.5px}
th{text-align:left;padding:10px 14px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--muted);border-bottom:1px solid var(--border)}
td{padding:12px 14px;border-bottom:1px solid rgba(31,45,69,.5);vertical-align:middle}
tr:last-child td{border-bottom:none}
tr:hover td{background:rgba(255,255,255,.02)}
.pill{display:inline-flex;align-items:center;gap:5px;padding:3px 10px;border-radius:20px;font-size:11.5px;font-weight:600}
.pill-dot{width:6px;height:6px;border-radius:50%}
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.65);z-index:200;display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(4px)}
.modal{background:var(--surface);border:1px solid var(--border);border-radius:16px;width:100%;max-width:620px;max-height:90vh;overflow-y:auto;animation:slideUp .2s ease}
@keyframes slideUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}
.modal-header{padding:20px 24px;border-bottom:1px solid var(--border);display:flex;justify-content:space-between;align-items:center}
.modal-header h3{font-size:15px;font-weight:700}
.modal-close{width:32px;height:32px;border-radius:8px;background:var(--surface2);border:none;cursor:pointer;color:var(--muted);font-size:18px;display:flex;align-items:center;justify-content:center;transition:all .15s}
.modal-close:hover{color:var(--text);background:var(--border)}
.modal-body{padding:24px}
.modal-footer{padding:16px 24px;border-top:1px solid var(--border);display:flex;justify-content:flex-end;gap:10px}
.uf-banner{background:linear-gradient(135deg,rgba(14,165,233,.1),rgba(56,189,248,.05));border:1px solid rgba(14,165,233,.2);border-radius:10px;padding:14px 18px;display:flex;align-items:center;gap:14px;margin-bottom:22px}
.uf-value{font-family:var(--mono);font-size:22px;font-weight:700;color:var(--accent)}
.uf-meta{font-size:12px;color:var(--muted);margin-top:2px}
.toast-container{position:fixed;bottom:24px;right:24px;z-index:999;display:flex;flex-direction:column;gap:8px}
.toast{background:var(--surface2);border:1px solid var(--border);border-radius:10px;padding:12px 16px;min-width:280px;display:flex;align-items:center;gap:10px;font-size:13px;animation:toastIn .25s ease;box-shadow:0 8px 30px rgba(0,0,0,.4)}
@keyframes toastIn{from{opacity:0;transform:translateX(20px)}to{opacity:1;transform:none}}
.tabs{display:flex;gap:4px;margin-bottom:20px;background:var(--surface2);padding:4px;border-radius:10px}
.tab{flex:1;padding:8px 14px;border-radius:7px;border:none;cursor:pointer;font-family:var(--font);font-size:13px;font-weight:600;transition:all .15s;color:var(--muted);background:transparent}
.tab.active{background:var(--surface);color:var(--text)}
.divider{border:none;border-top:1px solid var(--border);margin:20px 0}
.switch-row{display:flex;align-items:center;justify-content:space-between;padding:10px 0}
.switch-label{font-size:13px;font-weight:500}
.switch-sub{font-size:11.5px;color:var(--muted);margin-top:2px}
.switch{position:relative;width:40px;height:22px}
.switch input{opacity:0;width:0;height:0}
.slider{position:absolute;cursor:pointer;inset:0;background:var(--border);border-radius:22px;transition:.2s}
.slider:before{content:'';position:absolute;height:16px;width:16px;left:3px;bottom:3px;background:#fff;border-radius:50%;transition:.2s}
input:checked+.slider{background:var(--accent)}
input:checked+.slider:before{transform:translateX(18px)}
.login-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;background:var(--bg)}
.login-card{background:var(--surface);border:1px solid var(--border);border-radius:16px;padding:40px;width:100%;max-width:400px}
.login-title{font-size:22px;font-weight:700;margin-bottom:6px}
.login-sub{font-size:13px;color:var(--muted);margin-bottom:28px}
.warn-box{background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.25);border-radius:8px;padding:12px 14px;font-size:12.5px;color:var(--yellow);margin-bottom:16px}
.info-box{background:rgba(14,165,233,.08);border:1px solid rgba(14,165,233,.2);border-radius:8px;padding:12px 14px;font-size:12.5px;color:var(--accent)}
::-webkit-scrollbar{width:5px;height:5px}
::-webkit-scrollbar-track{background:transparent}
::-webkit-scrollbar-thumb{background:var(--border);border-radius:10px}
`;

/* ─── ICONOS ────────────────────────────────────────────────────────────────── */
const Ic = {
  Bolt:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
  Grid:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  Users:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  Doc:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  Cal:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  Gear:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93l-1.41 1.41M4.93 19.07l1.41-1.41M4.93 4.93l1.41 1.41M19.07 19.07l-1.41-1.41M12 2v2M12 20v2M2 12h2M20 12h2"/></svg>,
  Plus:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Send:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  Edit:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  Trash:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
  Mail:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  Spin:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>,
  Check:    ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>,
  Key:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="7.5" cy="15.5" r="5.5"/><path d="M21 2l-9.6 9.6M15.5 7.5l3 3"/></svg>,
  Download: ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  Cash:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>,
  List:     ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  LogOut:   ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  Eye:      ()=><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
};

/* ─── HELPERS ────────────────────────────────────────────────────────────────── */
function Field({ label, value, onChange, placeholder, type = "text", disabled }) {
  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <input className="form-input" type={type} value={value ?? ""} placeholder={placeholder}
        onChange={e => onChange && onChange(e.target.value)} disabled={disabled} />
    </div>
  );
}

function Modal({ title, onClose, onSave, saveLabel = "Guardar", saving, children }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">{children}</div>
        {onSave && (
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
            <button className="btn btn-primary" onClick={onSave} disabled={saving}>
              <Ic.Check />{saving ? "Guardando..." : saveLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function StatusPill({ status }) {
  const map = {
    aceptado:   ["badge-green",  "Aceptado SII"],
    pendiente:  ["badge-yellow", "Pendiente SII"],
    procesando: ["badge-blue",   "Procesando"],
    rechazado:  ["badge-red",    "Rechazado"],
    error:      ["badge-red",    "Error"],
    activo:     ["badge-green",  "Activo"],
    inactivo:   ["badge-red",    "Inactivo"],
    pagado:      ["badge-green",  "Pagado"],
    pago_parcial:["badge-yellow", "Pago parcial"],
    sin_pago:    ["badge-red",    "Sin pago"],
  };
  const [cls, label] = map[status] || ["badge-blue", status];
  const dotColor = cls.includes("green") ? "var(--green)" : cls.includes("yellow") ? "var(--yellow)"
    : cls.includes("red") ? "var(--red)" : "var(--accent)";
  return <span className={`pill ${cls}`}><span className="pill-dot" style={{ background: dotColor }}/>{label}</span>;
}

/* ─── LOGIN ──────────────────────────────────────────────────────────────────── */
function Login({ onLogin }) {
  const [email, setEmail] = useState("admin@facturacion.local");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async () => {
    setLoading(true); setErr("");
    try {
      const { token, user } = await api.login(email, password);
      localStorage.setItem("token", token);
      onLogin(user);
    } catch (e) { setErr(e.message); }
    setLoading(false);
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
          <Ic.Bolt /><span style={{ color: "var(--accent)", fontWeight: 700, fontSize: 15, letterSpacing: ".1em", textTransform: "uppercase" }}>OpenFactura</span>
        </div>
        <div className="login-title">Iniciar sesión</div>
        <div className="login-sub">Sistema de Facturación Automática</div>
        {err && <div className="warn-box">{err}</div>}
        <Field label="Correo" value={email} onChange={setEmail} placeholder="admin@facturacion.local" />
        <Field label="Contraseña" value={password} onChange={setPassword} type="password" placeholder="••••••••" />
        <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center", marginTop: 8 }}
          onClick={submit} disabled={loading}>
          {loading ? "Ingresando..." : "Ingresar"}
        </button>
        <div style={{ marginTop: 16, fontSize: 11.5, color: "var(--muted)", textAlign: "center" }}>
          Credenciales por defecto: admin@facturacion.local / Admin1234!<br/>Cámbia la contraseña después del primer ingreso.
        </div>
      </div>
    </div>
  );
}

/* ─── APP ROOT ───────────────────────────────────────────────────────────────── */
export default function App() {
  const [user, setUser] = useState(null);
  const isAdmin = user?.rol === "admin";
  const [ahora, setAhora] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setAhora(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  const [page, setPage] = useState("dashboard");
  const [uf, setUf] = useState(null);
  const [toasts, setToasts] = useState([]);
  const [loading, setLoading] = useState(true);

  const addToast = useCallback((msg, type = "info") => {
    const id = Date.now();
    setToasts(p => [...p, { id, msg, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 4500);
  }, []);

  // Verificar sesión existente
  useEffect(() => {
    if (localStorage.getItem("token")) {
      api.me().then(u => { setUser(u); setLoading(false); }).catch(() => {
        localStorage.removeItem("token"); setLoading(false);
      });
    } else setLoading(false);
  }, []);

  // Cargar UF
  useEffect(() => {
    if (user) api.ufHoy().then(setUf).catch(() => {});
  }, [user]);

  const logout = () => { localStorage.removeItem("token"); setUser(null); };

  if (loading) return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)", color: "var(--muted)" }}>Cargando…</div>;

  if (!user) return (
    <>
      <style>{STYLE}</style>
      <Login onLogin={u => { setUser(u); }} />
      <ToastContainer toasts={toasts} />
    </>
  );

  const nav = [
    { id: "dashboard",  label: "Dashboard",      icon: Ic.Grid },
    { id: "clientes",   label: "Clientes",        icon: Ic.Users },
    { id: "facturas",   label: "Facturas",         icon: Ic.Doc },
    { id: "programar",  label: "Programación",     icon: Ic.Cal },
    ...(isAdmin ? [{ id: "config", label: "Configuración", icon: Ic.Gear }] : []),
    ...(isAdmin ? [{ id: "usuarios", label: "Usuarios", icon: Ic.Key }] : []),
    { id: "logs",       label: "Logs",             icon: Ic.List },
  ];

  return (
    <>
      <style>{STYLE}</style>
      <div className="app">
        {/* SIDEBAR */}
        <div className="sidebar">
          <div className="sidebar-logo"><Ic.Bolt />OpenFactura</div>
          <nav className="sidebar-nav">
            {nav.map(n => (
              <div key={n.id} className={`nav-item${page === n.id ? " active" : ""}`} onClick={() => setPage(n.id)}>
                <n.icon />{n.label}
              </div>
            ))}
          </nav>
          <div style={{ padding: "0 10px 10px" }}>
            <div className="nav-item" onClick={logout} style={{ color: "var(--red)" }}><Ic.LogOut />Cerrar sesión</div>
          </div>
          <div className="sidebar-footer">{user.nombre}<br/>{user.email}</div>
        </div>

        {/* CONTENIDO */}
        <div className="main">
          {page === "dashboard"  && <Dashboard uf={uf} addToast={addToast} setPage={setPage} />}
          {page === "clientes"   && <Clientes uf={uf} addToast={addToast} />}
          {page === "facturas"   && <Facturas uf={uf} addToast={addToast} />}
          {page === "programar"  && <Programar uf={uf} addToast={addToast} />}
          {page === "config"     && <Configuracion addToast={addToast} />}
          {page === "usuarios"   && <Usuarios addToast={addToast} currentUser={user} />}
          {page === "logs"       && <Logs addToast={addToast} />}
        </div>
      </div>
      <ToastContainer toasts={toasts} />
    </>
  );
}

function ToastContainer({ toasts }) {
  const icons = { success: "✅", error: "❌", info: "ℹ️", warning: "⚠️" };
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div className="toast" key={t.id}>
          <span>{icons[t.type] || "ℹ️"}</span>
          <span>{t.msg}</span>
        </div>
      ))}
    </div>
  );
}

/* ─── DASHBOARD ──────────────────────────────────────────────────────────────── */
function Dashboard({ uf, addToast, setPage }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.dashboard().then(setData).catch(e => addToast(e.message, "error"));
  }, [addToast]);

  const refreshUF = () => {
    api.ufHoy().then(u => addToast(`UF actualizada: $${parseFloat(u.valor).toLocaleString("es-CL")}`, "success")).catch(e => addToast(e.message, "error"));
  };

  if (!data) return <div className="content" style={{ color: "var(--muted)" }}>Cargando datos…</div>;
  const { clientes: c, facturas: f, uf_ultimo, cron_reciente } = data;

  return (
    <>
      <div className="topbar">
        <div><div className="topbar-title">Dashboard</div><div className="topbar-sub">Resumen general del sistema</div></div>
        <button className="btn btn-primary btn-sm" onClick={() => setPage("programar")}><Ic.Bolt />Generar facturas</button>
      </div>
      <div className="content">
        <BackupStatus />
        {uf && (
          <div className="uf-banner">
            <div>
              <div style={{ fontSize: 11, color: "var(--muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".07em" }}>UF del día</div>
              <div className="uf-value">${parseFloat(uf.valor).toLocaleString("es-CL")}</div>
              <div className="uf-meta">{uf.fecha} — fuente: mindicador.cl</div>
            </div>
            <button className="btn btn-secondary btn-sm" onClick={refreshUF} style={{ marginLeft: "auto" }}>
              <Ic.Spin />Actualizar
            </button>
          </div>
        )}
        <div className="grid-4" style={{ marginBottom: 22 }}>
          <StatCard label="Clientes activos"     value={c.activos}    badge={`${c.total} total`}       badgeClass="badge-blue" />
          <StatCard label="Facturas pendientes"   value={f.pendientes} badge="por validar SII"          badgeClass="badge-yellow" />
          <StatCard label="Facturas aceptadas"    value={f.aceptadas}  badge="acumulado"                badgeClass="badge-green" />
          <StatCard label="Total facturado"       value={`$${parseInt(f.total_facturado || 0).toLocaleString("es-CL")}`} badge="CLP" badgeClass="badge-blue" />
        </div>
        <div className="card">
          <div className="card-title">Últimas ejecuciones del cron</div>
          {cron_reciente.length === 0
            ? <p style={{ color: "var(--muted)", fontSize: 13 }}>Sin ejecuciones registradas aún.</p>
            : <div className="table-wrap"><table>
                <thead><tr><th>Fecha/Hora</th><th>Clientes</th><th>OK</th><th>Errores</th></tr></thead>
                <tbody>
                  {cron_reciente.map(row => (
                    <tr key={row.id}>
                      <td style={{ fontFamily: "var(--mono)", fontSize: 12 }}>{new Date(row.ejecutado_at).toLocaleString("es-CL")}</td>
                      <td>{row.clientes_count}</td>
                      <td style={{ color: "var(--green)", fontWeight: 600 }}>{row.facturas_ok}</td>
                      <td style={{ color: row.facturas_error > 0 ? "var(--red)" : "var(--muted)" }}>{row.facturas_error}</td>
                    </tr>
                  ))}
                </tbody>
              </table></div>
          }
        </div>
      </div>
    </>
  );
}

function BackupStatus() {
  const [b, setB] = useState(null);
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    const cargar = () => api.backupEstado().then(d => { setB(d); setFallo(false); }).catch(() => setFallo(true));
    cargar();
    const t = setInterval(cargar, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  const mib = n => n == null ? "—" : n >= 1073741824 ? `${(n / 1073741824).toFixed(2)} GiB` : `${Math.round(n / 1048576)} MiB`;
  const estados = {
    ok:        { txt: "Respaldo al día",       cls: "badge-green",  color: "var(--green)" },
    alerta:    { txt: "Poco espacio libre",    cls: "badge-yellow", color: "var(--yellow)" },
    atrasado:  { txt: "Respaldo atrasado",     cls: "badge-yellow", color: "var(--yellow)" },
    error:     { txt: "Último respaldo falló", cls: "badge-red",    color: "var(--red)" },
    sin_datos: { txt: "Sin información",       cls: "badge-blue",   color: "var(--muted)" },
  };
  const e = estados[fallo ? "sin_datos" : (b && b.estado) || "sin_datos"] || estados.sin_datos;
  const dbx = b && b.dropbox;
  const pct = dbx && dbx.percent != null ? Math.min(100, Math.max(0, dbx.percent)) : null;
  const barColor = pct == null ? "var(--muted)" : pct >= 90 ? "var(--red)" : pct >= 75 ? "var(--yellow)" : "var(--accent)";
  const ultimo = b && b.last_run ? new Date(b.last_run) : null;
  const hace = b && b.horas_desde_ultimo != null
    ? (b.horas_desde_ultimo < 1 ? "hace menos de 1 hora" : `hace ${Math.round(b.horas_desde_ultimo)} h`) : null;

  return (
    <div className="card" style={{ marginBottom: 22 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div className="card-title" style={{ marginBottom: 0 }}>Respaldo de datos</div>
        <span className={`badge ${e.cls}`}>{e.txt}</span>
      </div>
      {fallo && <p style={{ color: "var(--muted)", fontSize: 13 }}>No se pudo consultar el estado del respaldo.</p>}
      {!fallo && b && b.estado === "sin_datos" && <p style={{ color: "var(--muted)", fontSize: 13 }}>{b.mensaje}</p>}
      {!fallo && b && b.estado !== "sin_datos" && (
        <>
          <div style={{ display: "flex", gap: 28, flexWrap: "wrap", marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 11, color: "var(--muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".07em" }}>Último respaldo</div>
              <div style={{ fontFamily: "var(--mono)", fontSize: 14, color: e.color }}>
                {ultimo ? ultimo.toLocaleString("es-CL") : "—"}{hace ? ` · ${hace}` : ""}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".07em" }}>Copias disponibles</div>
              <div style={{ fontFamily: "var(--mono)", fontSize: 14 }}>
                {b.copies ? `${b.copies.daily} diarias · ${b.copies.weekly} semanales` : "—"}
              </div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".07em" }}>Tamaño por copia</div>
              <div style={{ fontFamily: "var(--mono)", fontSize: 14 }}>{mib(b.backup_size_bytes)}</div>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".07em" }}>Próximo respaldo</div>
              <div style={{ fontFamily: "var(--mono)", fontSize: 14 }}>{b.next_run || "—"}</div>
            </div>
          </div>
          {pct != null && (
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "var(--muted)", marginBottom: 6 }}>
                <span>Espacio usado en Dropbox</span>
                <span style={{ fontFamily: "var(--mono)", color: barColor }}>{pct.toFixed(0)}% · {mib(dbx.used)} de {mib(dbx.total)} · libres {mib(dbx.free)}</span>
              </div>
              <div style={{ height: 8, background: "var(--surface2)", borderRadius: 6, overflow: "hidden" }}>
                <div style={{ width: `${pct}%`, height: "100%", background: barColor, transition: "width .4s" }} />
              </div>
            </div>
          )}
          {b.mensaje && b.estado !== "ok" && (
            <p style={{ marginTop: 12, fontSize: 13, color: e.color }}>{b.mensaje}</p>
          )}
        </>
      )}
    </div>
  );
}

function StatCard({ label, value, badge, badgeClass }) {
  return (
    <div className="stat-card">
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value ?? "—"}</div>
      <span className={`stat-badge ${badgeClass}`}>{badge}</span>
    </div>
  );
}

/* ─── PREVIEW FACTURA ───────────────────────────────────────────────────────── */
function PreviewFactura({ cliente, uf, onClose }) {
  const hoy = new Date();
  const meses = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];
  const capFirst = s => s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  const fmtFecha = d => `${d.getDate()} ${capFirst(meses[d.getMonth()])} ${d.getFullYear()}`;
  const diasSemana = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"];

  const anio = hoy.getFullYear();
  const mes  = hoy.getMonth() + 1;
  const dia  = cliente.dia_facturacion || 1;

  const ultimoDia = (a, m) => new Date(a, m, 0).getDate();
  const fIni = new Date(anio, mes-1, Math.min(dia, ultimoDia(anio, mes)));
  let mesP = mes+1, anioP = anio;
  if (mesP > 12) { mesP = 1; anioP++; }
  const diaFin = Math.min(dia, ultimoDia(anioP, mesP)) - 1;
  const fFin = diaFin <= 0 ? new Date(anioP, mesP-1, 0) : new Date(anioP, mesP-1, diaFin);
  const mismoMes = fIni.getMonth() === fFin.getMonth() && fIni.getFullYear() === fFin.getFullYear();
  const periodo = mismoMes
    ? capFirst(meses[fIni.getMonth()]) + " " + fIni.getFullYear()
    : fmtFecha(fIni) + " al " + fmtFecha(fFin);

  const ufValor = uf ? parseFloat(uf.valor) : 0;
  const items = cliente.items_json && Array.isArray(cliente.items_json) && cliente.items_json.length > 1
    ? cliente.items_json : null;

  let detalles = [];
  let mntNeto = 0;

  if (items) {
    items.forEach((item, i) => {
      const precio = item.moneda === "UF" ? Math.round(parseFloat(item.monto) * ufValor) : Math.round(parseFloat(item.monto));
      mntNeto += precio;
      const extra = item.moneda === "UF" ? ` (${item.monto} UF x $${ufValor.toLocaleString("es-CL")})` : "";
      detalles.push({ codigo: String(i+1).padStart(3,"0"), desc: `${item.descripcion} ${periodo}${extra}`, precio });
    });
  } else {
    mntNeto = cliente.moneda === "UF" ? Math.round(parseFloat(cliente.monto) * ufValor) : Math.round(parseFloat(cliente.monto));
    const extra = cliente.moneda === "UF" ? ` (${cliente.monto} UF x $${ufValor.toLocaleString("es-CL")})` : "";
    detalles.push({ codigo: "001", desc: `${cliente.descripcion_servicio || "Servicio acceso internet"} ${periodo}${extra}`, precio: mntNeto });
  }

  const iva   = Math.round(mntNeto * 0.19);
  const total = mntNeto + iva;
  const fechaLarga = `${diasSemana[hoy.getDay()]} ${hoy.getDate()} de ${meses[hoy.getMonth()]} del ${hoy.getFullYear()}`;

  const tdL = { padding:"3px 6px", fontSize:11, color:"#111", verticalAlign:"top" };
  const tdR = { padding:"3px 6px", fontSize:11, color:"#111", verticalAlign:"top", textAlign:"right" };

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.75)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}
         onClick={onClose}>
      <div style={{ background:"#fff", width:"100%", maxWidth:760, maxHeight:"92vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,.5)", fontFamily:"Arial,sans-serif" }}
           onClick={e => e.stopPropagation()}>

        {/* HEADER */}
        <table width="100%" cellPadding="0" cellSpacing="0" style={{ borderBottom:"1px solid #ccc", padding:12 }}>
          <tbody><tr>
            <td width="60%" style={{ verticalAlign:"top", padding:10 }}>
              <table cellPadding="0" cellSpacing="0"><tbody><tr>
                <td style={{ paddingRight:12 }}>
                  <img src="https://dte.optiwisp.cl/logo.png" alt="OptiWisp" style={{ height:60, objectFit:"contain" }} />
                </td>
                <td style={{ verticalAlign:"middle" }}>
                  <div style={{ fontWeight:700, fontSize:12, color:"#000" }}>OPTIWISP SPA</div>
                  <div style={{ fontSize:10, color:"#333" }}>PROVEEDOR DE SERVICIOS DE INTERNET</div>
                  <div style={{ fontSize:10, color:"#333" }}>OTRAS ACTIVIDADES DE TELECOMUNICACIONES N.C.P.</div>
                  <div style={{ fontSize:10, color:"#333" }}>CAM SAN FRANCISCO S/N EL HIGUERAL, SAN ESTEBAN</div>
                  <div style={{ fontSize:10, color:"#333" }}>contacto@optiwisp.cl</div>
                </td>
              </tr></tbody></table>
            </td>
            <td width="40%" style={{ verticalAlign:"top", padding:10 }}>
              <div style={{ border:"2px solid #e00", padding:"8px 12px", textAlign:"center" }}>
                <div style={{ color:"#e00", fontWeight:700, fontSize:13 }}>R.U.T.: 76.698.371-5</div>
                <div style={{ color:"#e00", fontWeight:700, fontSize:13, marginTop:4 }}>FACTURA ELECTRÓNICA</div>
                <div style={{ color:"#e00", fontWeight:700, fontSize:13, marginTop:4 }}>FOLIO NO ASIGNADO</div>
              </div>
              <div style={{ textAlign:"center", color:"#e00", fontWeight:700, fontSize:12, marginTop:6 }}>S.I.I. LOS ANDES</div>
            </td>
          </tr></tbody>
        </table>

        {/* FECHA */}
        <div style={{ textAlign:"right", padding:"4px 16px", fontSize:11, color:"#333", borderBottom:"1px solid #eee" }}>
          {fechaLarga}
        </div>

        {/* RECEPTOR + CONDICIONES */}
        <table width="100%" cellPadding="0" cellSpacing="0" style={{ borderBottom:"1px solid #ccc", margin:"0" }}>
          <tbody><tr>
            <td width="55%" style={{ padding:"8px 12px", verticalAlign:"top", borderRight:"1px solid #ccc" }}>
              <table cellPadding="2" cellSpacing="0"><tbody>
                <tr>
                  <td style={{ ...tdL, fontWeight:700, width:80 }}>R.U.T.</td>
                  <td style={{ ...tdL }}>: {cliente.rut}</td>
                </tr>
                <tr>
                  <td style={{ ...tdL, fontWeight:700 }}>SEÑOR (ES)</td>
                  <td style={{ ...tdL }}>: {cliente.razon_social}</td>
                </tr>
                <tr>
                  <td style={{ ...tdL, fontWeight:700 }}>GIRO</td>
                  <td style={{ ...tdL }}>: {cliente.giro || "SIN INFORMACIÓN"}</td>
                </tr>
                <tr>
                  <td style={{ ...tdL, fontWeight:700 }}>DIRECCIÓN</td>
                  <td style={{ ...tdL }}>: {cliente.direccion || "SIN INFORMACIÓN"}, {cliente.comuna || ""}</td>
                </tr>
                <tr>
                  <td style={{ ...tdL, fontWeight:700 }}>EMAIL</td>
                  <td style={{ ...tdL }}>: {cliente.email_principal || "SIN EMAIL"}</td>
                </tr>
              </tbody></table>
            </td>
            <td width="45%" style={{ padding:"8px 12px", verticalAlign:"top" }}>
              <table cellPadding="2" cellSpacing="0"><tbody>
                <tr>
                  <td style={{ ...tdL, fontWeight:700, width:100 }}>Forma de pago</td>
                  <td style={{ ...tdL }}>: Contado</td>
                </tr>
                <tr>
                  <td style={{ ...tdL, fontWeight:700 }}>Tipo Venta</td>
                  <td style={{ ...tdL }}>: Ventas del Giro.</td>
                </tr>
                <tr>
                  <td style={{ ...tdL, fontWeight:700 }}>Tipo Compra</td>
                  <td style={{ ...tdL }}>: Compras del Giro.</td>
                </tr>
              </tbody></table>
            </td>
          </tr></tbody>
        </table>

        {/* TABLA ITEMS */}
        <table width="100%" cellPadding="0" cellSpacing="0" style={{ borderBottom:"1px solid #ccc" }}>
          <thead>
            <tr style={{ background:"#1e3a5f" }}>
              <td colSpan="5" style={{ textAlign:"center", color:"#fff", fontWeight:700, fontSize:12, padding:"6px" }}>DETALLE DE ITEMS</td>
            </tr>
            <tr style={{ background:"#2563a8" }}>
              <td style={{ ...tdL, color:"#fff", fontWeight:700, width:60 }}>Código</td>
              <td style={{ ...tdL, color:"#fff", fontWeight:700 }}>Item</td>
              <td style={{ ...tdR, color:"#fff", fontWeight:700, width:70 }}>Cantidad</td>
              <td style={{ ...tdR, color:"#fff", fontWeight:700, width:90 }}>Precio</td>
              <td style={{ ...tdR, color:"#fff", fontWeight:700, width:90 }}>Subtotal</td>
            </tr>
          </thead>
          <tbody>
            {detalles.map((d, i) => (
              <tr key={i} style={{ borderBottom:"1px solid #eee", background: i%2===0?"#fff":"#f9f9f9" }}>
                <td style={{ ...tdL }}>{d.codigo}</td>
                <td style={{ ...tdL }}>{d.desc}</td>
                <td style={{ ...tdR }}>1</td>
                <td style={{ ...tdR }}>${d.precio.toLocaleString("es-CL")}</td>
                <td style={{ ...tdR }}>${d.precio.toLocaleString("es-CL")}</td>
              </tr>
            ))}
            <tr style={{ height:120 }}><td colSpan="5"></td></tr>
          </tbody>
        </table>

        {/* TOTALES */}
        <table width="100%" cellPadding="0" cellSpacing="0">
          <tbody><tr>
            <td width="60%"></td>
            <td width="40%">
              <table width="100%" cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr style={{ background:"#1e3a5f" }}>
                    <td style={{ ...tdL, color:"#fff", fontWeight:700, padding:"5px 10px" }}>MONTO NETO</td>
                    <td style={{ ...tdR, color:"#fff", fontWeight:700, padding:"5px 10px" }}>$ {mntNeto.toLocaleString("es-CL")}</td>
                  </tr>
                  <tr style={{ background:"#2563a8" }}>
                    <td style={{ ...tdL, color:"#fff", padding:"5px 10px" }}>IVA 19%</td>
                    <td style={{ ...tdR, color:"#fff", padding:"5px 10px" }}>$ {iva.toLocaleString("es-CL")}</td>
                  </tr>
                  <tr style={{ background:"#1e3a5f" }}>
                    <td style={{ ...tdL, color:"#fff", fontWeight:700, padding:"5px 10px" }}>MONTO TOTAL</td>
                    <td style={{ ...tdR, color:"#fff", fontWeight:700, padding:"5px 10px" }}>$ {total.toLocaleString("es-CL")}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr></tbody>
        </table>

        {/* FOOTER */}
        <div style={{ padding:"8px 16px", borderTop:"1px solid #eee", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div style={{ fontSize:10, color:"#999" }}>Preview estimado — Sin validez tributaria — El folio se asigna al emitir</div>
          <button className="btn btn-secondary btn-sm" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}

/* ─── CLIENTES ───────────────────────────────────────────────────────────────── */
function Clientes({ uf, addToast }) {
  const [list, setList] = useState([]);
  const [modal, setModal] = useState(null);
  const [busqueda, setBusqueda] = useState("");
  const [preview, setPreview] = useState(null);
  const [cuenta, setCuenta] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);

  const load = useCallback(() => api.clientes().then(setList).catch(e => addToast(e.message, "error")), [addToast]);
  const listFiltrada = list.filter(c => {
    if (!busqueda) return true;
    const q = busqueda.toLowerCase();
    return (c.razon_social||"").toLowerCase().includes(q) ||
           (c.rut||"").toLowerCase().includes(q) ||
           (c.alias||"").toLowerCase().includes(q) ||
           (c.email_principal||"").toLowerCase().includes(q) ||
           (c.comuna||"").toLowerCase().includes(q);
  });
  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPage(1); }, [busqueda, pageSize]);

  // Con 2+ ítems en la misma moneda que el cliente, el monto base se calcula sumando los ítems
  // (así es como cron.js calcula la factura real). Si las monedas están mezcladas, no se puede
  // resumir en un solo número sin convertir a la UF del día, así que se deja manual.
  useEffect(() => {
    const items = form.items_json || [];
    if (items.length > 1 && items.every(it => it.moneda === form.moneda)) {
      const suma = Math.round(items.reduce((s, it) => s + (parseFloat(it.monto) || 0), 0) * 100) / 100;
      setForm(p => (p.monto === suma ? p : { ...p, monto: suma }));
    }
  }, [form.items_json, form.moneda]);

  const totalPaginas = Math.max(1, Math.ceil(listFiltrada.length / pageSize));
  const paginaActual = Math.min(page, totalPaginas);
  const inicio = (paginaActual - 1) * pageSize;
  const listPagina = listFiltrada.slice(inicio, inicio + pageSize);

  const set = k => v => setForm(p => ({ ...p, [k]: v }));

  const openNew = () => {
    setForm({ rut: "", razon_social: "", giro: "", direccion: "", comuna: "", contacto: "", emails: "", moneda: "CLP", monto: "", dia_facturacion: 1, activo: true, notas: "", descripcion_servicio: "", forma_pago: "contado", dias_credito: 30 });
    setModal("new");
  };
  const openEdit = c => { setForm({ ...c, emails: (c.emails || []).join(", ") }); setModal(c); };

  const save = async () => {
    setSaving(true);
    try {
      const emailArr = (form.emails || "").split(",").map(e => e.trim()).filter(Boolean);
      const body = { ...form, emails: emailArr, email_principal: emailArr[0] || "", monto: parseFloat(form.monto) || 0, dia_facturacion: parseInt(form.dia_facturacion) || 1 };
      // Verificar si el RUT ya existe y requiere alias
      if (modal === "new") {
        const existentes = list.filter(c => c.rut === form.rut);
        if (existentes.length > 0 && !form.alias) {
          addToast("Este RUT ya existe. Debes ingresar un Alias para diferenciarlo (ej: Proyecto Norte)", "error");
          setSaving(false);
          return;
        }
        await api.clienteCreate(body); addToast("Cliente creado", "success");
      }
      else { await api.clienteUpdate(modal.id, body); addToast("Cliente actualizado", "success"); }
      setModal(null); load();
    } catch (e) { addToast(e.message, "error"); }
    setSaving(false);
  };

  const del = async c => {
    if (!window.confirm(`¿Eliminar a ${c.razon_social}?`)) return;
    try { await api.clienteDelete(c.id); addToast("Cliente eliminado", "info"); load(); }
    catch (e) { addToast(e.message, "error"); }
  };

  return (
    <>
      <div className="topbar">
        <div><div className="topbar-title">Clientes</div><div className="topbar-sub">{listFiltrada.length} de {list.length} registrados</div></div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <div style={{ position: "relative" }}>
            <input className="form-input" style={{ width: 240, paddingLeft: 32, fontSize: 13 }}
              placeholder="Buscar nombre, RUT, alias..." value={busqueda}
              onChange={e => setBusqueda(e.target.value)} />
            <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "var(--muted)" }}>🔍</span>
          </div>
          <select className="form-select" style={{ width: 130, padding: "7px 12px", fontSize: 13 }}
            value={pageSize} onChange={e => setPageSize(parseInt(e.target.value))} title="Clientes por página">
            {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n} por página</option>)}
            <option value={999999}>Ver todos</option>
          </select>
          <button className="btn btn-primary btn-sm" onClick={openNew}><Ic.Plus />Nuevo cliente</button>
        </div>
      </div>
      <div className="content">
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead><tr><th>RUT</th><th>Razón Social</th><th>Moneda</th><th>Monto</th><th>Pago</th><th>Día facturación</th><th>Correos</th><th>Estado</th><th></th></tr></thead>
              <tbody>
                {listPagina.map(c => {
                  const montoClp = c.moneda === "UF" && uf ? Math.round(parseFloat(c.monto) * parseFloat(uf.valor)) : null;
                  return (
                    <tr key={c.id}>
                      <td style={{ fontFamily: "var(--mono)", fontSize: 12 }}>{c.rut}</td>
                      <td style={{ fontWeight: 600 }}>
                        {c.razon_social}
                        {c.alias ? <span style={{ marginLeft: 8, fontSize: 11, color: "var(--accent)", background: "rgba(14,165,233,.1)", padding: "2px 8px", borderRadius: 10, fontWeight: 600 }}>— {c.alias}</span> : null}
                        {c.credito_saldo > 0 ? <span style={{ marginLeft: 8, fontSize: 11, color: "var(--green)", background: "rgba(34,197,94,.1)", padding: "2px 8px", borderRadius: 10, fontWeight: 600 }}>Saldo a favor ${parseInt(c.credito_saldo).toLocaleString("es-CL")}</span> : null}
                      </td>
                      <td><span className={`pill ${c.moneda === "UF" ? "badge-blue" : "badge-green"}`}>{c.moneda}</span></td>
                      <td style={{ fontFamily: "var(--mono)", fontSize: 13 }}>
                        {c.moneda === "UF"
                          ? <>{c.monto} UF{montoClp ? <span style={{ color: "var(--muted)", fontSize: 11, marginLeft: 5 }}>≈${montoClp.toLocaleString("es-CL")}</span> : null}</>
                          : <>${parseFloat(c.monto).toLocaleString("es-CL")} <span style={{ background: "rgba(34,197,94,.12)", color: "var(--green)", fontSize: 10, fontWeight: 700, padding: "1px 6px", borderRadius: 10, marginLeft: 4, fontFamily: "var(--font)" }}>CLP</span></>}
                      </td>
                      <td><span className={`pill ${c.forma_pago === "credito" ? "badge-yellow" : "badge-blue"}`}>{c.forma_pago === "credito" ? `Crédito ${c.dias_credito}d` : "Contado"}</span></td>
                      <td style={{ textAlign: "center" }}>Día {c.dia_facturacion}</td>
                      <td style={{ fontSize: 12, color: "var(--muted)", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{(c.emails || []).join(", ")}</td>
                      <td><StatusPill status={c.activo ? "activo" : "inactivo"} /></td>
                      <td>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button className="btn btn-sm" style={{ background:"rgba(14,165,233,.15)", color:"var(--accent)", border:"1px solid rgba(14,165,233,.3)" }} onClick={() => setPreview(c)} title="Preview">&#128065;</button>
                          <button className="btn btn-sm" style={{ background:"rgba(34,197,94,.15)", color:"var(--green)", border:"1px solid rgba(34,197,94,.3)" }} onClick={() => setCuenta(c)} title="Estado de cuenta"><Ic.Cash /></button>
                          <button className="btn btn-secondary btn-sm" onClick={() => openEdit(c)}><Ic.Edit /></button>
                          <button className="btn btn-danger btn-sm" onClick={() => del(c)}><Ic.Trash /></button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {listFiltrada.length > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 4px 4px" }}>
              <span style={{ fontSize: 12.5, color: "var(--muted)" }}>
                Mostrando {inicio + 1}–{Math.min(inicio + pageSize, listFiltrada.length)} de {listFiltrada.length}
              </span>
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(1)} disabled={paginaActual === 1}>«</button>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={paginaActual === 1}>‹ Anterior</button>
                <span style={{ fontSize: 13, padding: "0 8px", color: "var(--text)" }}>Página {paginaActual} de {totalPaginas}</span>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(p => Math.min(totalPaginas, p + 1))} disabled={paginaActual === totalPaginas}>Siguiente ›</button>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(totalPaginas)} disabled={paginaActual === totalPaginas}>»</button>
              </div>
            </div>
          )}
        </div>
      </div>

      {preview && <PreviewFactura cliente={preview} uf={uf} onClose={() => setPreview(null)} />}
      {cuenta && <EstadoCuenta cliente={cuenta} onClose={() => setCuenta(null)} addToast={addToast} />}
      {modal && (
        <Modal title={modal === "new" ? "Nuevo cliente" : "Editar cliente"} onClose={() => setModal(null)} onSave={save} saving={saving}>
          <div className="grid-2">
            <div className="form-group">
            <label className="form-label">RUT</label>
            <input
              className="form-input"
              value={form.rut ?? ""}
              placeholder="76430498-5"
              onChange={e => set("rut")(e.target.value)}
              onBlur={async e => {
                const rut = e.target.value.trim().replace(/\./g, "");
                if (!rut || modal !== "new") return;
                try {
                  const r = await fetch(`https://api.boostr.cl/rut/name/${rut}.json`, {
                    headers: { accept: "application/json" }
                  });
                  const json = await r.json();
                  if (json.status !== "success") throw new Error();
                  setForm(p => ({
                    ...p,
                    razon_social: p.razon_social || json.data.name,
                  }));
                  addToast("Nombre cargado ✓", "success");
                } catch {
                  try {
                    const data = await api.contribuyente(rut);
                    setForm(p => ({
                      ...p,
                      razon_social: p.razon_social || data.razon_social,
                      giro:         p.giro         || data.giro,
                    }));
                    addToast("Datos del SII cargados ✓", "success");
                  } catch {
                    addToast("RUT no encontrado", "warning");
                  }
                }
              }}
            />
          </div>
            <Field label="Razón Social" value={form.razon_social} onChange={set("razon_social")} />
          </div>
          <Field label="Alias / Proyecto" value={form.alias || ""} onChange={set("alias")} placeholder="Ej: Proyecto Norte, Servicio Fibra" />
          <Field label="Giro" value={form.giro} onChange={set("giro")} />
          <div className="grid-2">
            <Field label="Dirección" value={form.direccion} onChange={set("direccion")} />
            <Field label="Comuna" value={form.comuna} onChange={set("comuna")} />
          </div>
          <div className="grid-2">
            <Field label="Teléfono / Contacto" value={form.contacto} onChange={set("contacto")} />
            <div className="form-group">
              <label className="form-label">Moneda</label>
              <select className="form-select" value={form.moneda} onChange={e => set("moneda")(e.target.value)}>
                <option value="CLP">CLP – Pesos chilenos</option>
                <option value="UF">UF – Unidad de Fomento</option>
              </select>
            </div>
          </div>
          <div className="grid-2">
            <div className="form-group">
              <label className="form-label">{form.moneda === "UF" ? "Monto (UF)" : "Monto (CLP)"}</label>
              {(() => {
                const items = form.items_json || [];
                const monedaUniforme = items.length > 1 && items.every(it => it.moneda === form.moneda);
                const monedaMixta = items.length > 1 && !monedaUniforme;
                return (
                  <>
                    <input className="form-input" type="number" value={form.monto ?? ""} onChange={e => set("monto")(e.target.value)}
                      disabled={monedaUniforme} />
                    {monedaUniforme && (
                      <div style={{ fontSize: 11.5, color: "var(--muted)", marginTop: 5 }}>
                        Calculado automáticamente sumando los {items.length} ítems.
                      </div>
                    )}
                    {monedaMixta && (
                      <div style={{ fontSize: 11.5, color: "var(--yellow)", marginTop: 5 }}>
                        Ítems en monedas distintas — este campo es solo referencial, la factura real se calcula sumando cada ítem en su propia moneda.
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
            <Field label="Día de facturación (1–28)" value={form.dia_facturacion} onChange={set("dia_facturacion")} type="number" />
          </div>
          <Field label="Correos destino (separados por coma)" value={form.emails} onChange={set("emails")} placeholder="fac@empresa.cl, otro@empresa.cl" />
          <div className="switch-row">
            <div><div className="switch-label">Venta a crédito</div><div className="switch-sub">Marca el DTE como Crédito en vez de Contado (agrega fecha de vencimiento)</div></div>
            <label className="switch">
              <input type="checkbox" checked={form.forma_pago === "credito"}
                onChange={e => set("forma_pago")(e.target.checked ? "credito" : "contado")}/><span className="slider"/>
            </label>
          </div>
          {form.forma_pago === "credito" && (
            <Field label="Días de crédito (plazo de pago)" value={form.dias_credito} onChange={set("dias_credito")} type="number" placeholder="30" />
          )}
          <div className="form-group">
            <label className="form-label">Descripción del servicio (aparece en la factura)</label>
            <input className="form-input" value={form.descripcion_servicio || ""} onChange={e => set("descripcion_servicio")(e.target.value)} placeholder="Servicio acceso internet" disabled={(form.items_json||[]).length > 0} />
            <div style={{ fontSize: 11.5, color: "var(--muted)", marginTop: 5 }}>
              El mes y año se agregan automáticamente. Si usas múltiples ítems, la descripción se ignora.
            </div>
          </div>

          {/* Editor de ítems múltiples */}
          <div className="form-group">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <label className="form-label" style={{ margin: 0 }}>Ítems de la factura ({(form.items_json||[]).length} ítems)</label>
              <button type="button" className="btn btn-secondary btn-sm" onClick={() => {
                const items = [...(form.items_json||[]), { descripcion: "Servicio acceso internet", monto: "", moneda: "CLP" }];
                set("items_json")(items);
              }}>+ Agregar ítem</button>
            </div>
            {(form.items_json||[]).length === 0 && (
              <div style={{ fontSize: 12, color: "var(--muted)", padding: "8px 12px", background: "var(--surface2)", borderRadius: 6 }}>
                Sin ítems adicionales — se usa la descripción del servicio como ítem único.
              </div>
            )}
            {(form.items_json||[]).map((item, i) => (
              <div key={i} style={{ display: "grid", gridTemplateColumns: "1fr 120px 80px 32px", gap: 8, marginBottom: 8, alignItems: "center" }}>
                <input className="form-input" style={{ fontSize: 13 }} value={item.descripcion} placeholder="Descripción del ítem"
                  onChange={e => { const its = [...form.items_json]; its[i].descripcion = e.target.value; set("items_json")(its); }} />
                <input className="form-input" style={{ fontSize: 13 }} value={item.monto} placeholder="Monto" type="number"
                  onChange={e => { const its = [...form.items_json]; its[i].monto = e.target.value; set("items_json")(its); }} />
                <select className="form-select" style={{ fontSize: 13 }} value={item.moneda}
                  onChange={e => { const its = [...form.items_json]; its[i].moneda = e.target.value; set("items_json")(its); }}>
                  <option value="CLP">CLP</option>
                  <option value="UF">UF</option>
                </select>
                <button type="button" className="btn btn-danger btn-sm" onClick={() => {
                  const its = form.items_json.filter((_,j) => j !== i); set("items_json")(its);
                }}><Ic.Trash /></button>
              </div>
            ))}
          </div>
          <div className="form-group">
            <label className="form-label">Notas internas</label>
            <textarea className="form-textarea" value={form.notas || ""} onChange={e => set("notas")(e.target.value)} />
          </div>
          <div className="switch-row">
            <div><div className="switch-label">Cliente activo</div><div className="switch-sub">Incluir en facturación automática</div></div>
            <label className="switch"><input type="checkbox" checked={!!form.activo} onChange={e => set("activo")(e.target.checked)}/><span className="slider"/></label>
          </div>
        </Modal>
      )}
    </>
  );
}

/* ─── ESTADO DE CUENTA ───────────────────────────────────────────────────────── */
function EstadoCuenta({ cliente, onClose, addToast }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [abonoForm, setAbonoForm] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    api.estadoCuenta(cliente.id)
      .then(setData)
      .catch(e => addToast(e.message, "error"))
      .finally(() => setLoading(false));
  }, [cliente.id, addToast]);

  useEffect(() => { load(); }, [load]);

  const abrirAbono = () => setAbonoForm({
    fecha_pago: new Date().toISOString().split("T")[0],
    banco: "", num_operacion: "", monto: "", observaciones: "",
  });
  const setA = k => v => setAbonoForm(p => ({ ...p, [k]: v }));

  const guardarAbono = async () => {
    if (!abonoForm.banco || !parseInt(abonoForm.monto)) {
      addToast("Banco y monto son requeridos", "error");
      return;
    }
    setSaving(true);
    try {
      const r = await api.registrarAbono({
        cliente_id: cliente.id,
        fecha_pago: abonoForm.fecha_pago,
        banco: abonoForm.banco,
        num_operacion: abonoForm.num_operacion,
        monto: parseInt(abonoForm.monto),
        observaciones: abonoForm.observaciones,
      });
      const n = r.aplicaciones.length;
      let msg = n > 0
        ? `Abono aplicado a ${n} factura${n === 1 ? "" : "s"}`
        : "Abono registrado — no hay facturas pendientes a las que aplicarlo";
      if (r.excedente_no_aplicado > 0) msg += `. Se guardaron $${r.excedente_no_aplicado.toLocaleString("es-CL")} como saldo a favor para la próxima factura.`;
      addToast(msg, "success");
      setAbonoForm(null);
      load();
    } catch (e) { addToast(e.message, "error"); }
    setSaving(false);
  };

  const borrarPago = async p => {
    if (!window.confirm(`¿Eliminar este pago de $${parseInt(p.monto_pagado).toLocaleString("es-CL")}?`)) return;
    try { await api.eliminarPago(p.id); addToast("Pago eliminado", "info"); load(); }
    catch (e) { addToast(e.message, "error"); }
  };

  const revertirAbono = async a => {
    if (!window.confirm(`¿Revertir el abono #${a.id} completo? Se eliminarán todos los pagos que generó.`)) return;
    try { await api.eliminarAbono(a.id); addToast("Abono revertido", "info"); load(); }
    catch (e) { addToast(e.message, "error"); }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 980 }}>
        <div className="modal-header">
          <h3>Estado de cuenta — {cliente.razon_social}{cliente.alias ? ` (${cliente.alias})` : ""}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {loading && <div style={{ color: "var(--muted)", padding: 20 }}>Cargando…</div>}
          {!loading && data && (
            <>
              <div style={{ fontSize: 12.5, color: "var(--muted)", marginBottom: 16, fontFamily: "var(--mono)" }}>{cliente.rut}</div>
              <div className="grid-3" style={{ marginBottom: 20 }}>
                <div className="stat-card">
                  <div className="stat-label">Total facturado</div>
                  <div className="stat-value">${data.resumen.total_facturado.toLocaleString("es-CL")}</div>
                </div>
                <div className="stat-card">
                  <div className="stat-label">Total pagado</div>
                  <div className="stat-value" style={{ color: "var(--green)" }}>${data.resumen.total_pagado.toLocaleString("es-CL")}</div>
                </div>
                <div className="stat-card">
                  <div className="stat-label">Saldo pendiente</div>
                  <div className="stat-value" style={{ color: data.resumen.saldo_pendiente > 0 ? "var(--red)" : "var(--green)" }}>
                    ${data.resumen.saldo_pendiente.toLocaleString("es-CL")}
                  </div>
                  <div style={{ marginTop: 6 }}>
                    <span className="pill badge-green" style={{ marginRight: 5 }}>{data.resumen.n_pagadas} pagadas</span>
                    <span className="pill badge-yellow" style={{ marginRight: 5 }}>{data.resumen.n_pago_parcial} parcial</span>
                    <span className="pill badge-red">{data.resumen.n_sin_pago} sin pago</span>
                  </div>
                </div>
              </div>

              {data.cliente.credito_saldo > 0 && (
                <div className="uf-banner" style={{ marginBottom: 20, borderColor: "rgba(34,197,94,.3)", background: "linear-gradient(135deg,rgba(34,197,94,.1),rgba(34,197,94,.03))" }}>
                  <div>
                    <div className="uf-value" style={{ color: "var(--green)" }}>${data.cliente.credito_saldo.toLocaleString("es-CL")}</div>
                    <div className="uf-meta">Saldo a favor — se descontará automáticamente de la próxima factura que se le emita</div>
                  </div>
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <div className="card-title" style={{ margin: 0 }}>Facturas</div>
                <button className="btn btn-primary btn-sm" onClick={abrirAbono}><Ic.Plus />Cargar abono</button>
              </div>
              <div className="card" style={{ marginBottom: 20 }}>
                <div className="table-wrap">
                  <table>
                    <thead><tr><th>Folio</th><th>Fecha</th><th>Total</th><th>Pagado</th><th>Saldo</th><th>SII</th><th>Pago</th></tr></thead>
                    <tbody>
                      {data.facturas.length === 0 && (
                        <tr><td colSpan={7} style={{ textAlign: "center", color: "var(--muted)", padding: 16 }}>Sin facturas emitidas</td></tr>
                      )}
                      {data.facturas.map(f => (
                        <tr key={f.id}>
                          <td style={{ fontFamily: "var(--mono)" }}><FolioLink folio={f.folio} facturaId={f.id} tienePdf={f.tiene_pdf} addToast={addToast} /></td>
                          <td style={{ fontSize: 12.5 }}>{String(f.fecha_emision).split("T")[0]}</td>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 13 }}>${parseInt(f.monto_total).toLocaleString("es-CL")}</td>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 13, color: "var(--green)" }}>${parseInt(f.monto_pagado).toLocaleString("es-CL")}</td>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 13, color: f.saldo > 0 ? "var(--red)" : "var(--muted)" }}>${f.saldo.toLocaleString("es-CL")}</td>
                          <td><StatusPill status={f.estado} /></td>
                          <td><StatusPill status={f.estado_pago || "sin_pago"} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="card-title">Abonos registrados</div>
              <div className="card" style={{ marginBottom: 20 }}>
                <div className="table-wrap">
                  <table>
                    <thead><tr><th>Fecha</th><th>Banco</th><th>N° Operación</th><th>Monto</th><th>Aplicado</th><th>Excedente</th><th></th></tr></thead>
                    <tbody>
                      {data.abonos.length === 0 && (
                        <tr><td colSpan={7} style={{ textAlign: "center", color: "var(--muted)", padding: 16 }}>Sin abonos registrados</td></tr>
                      )}
                      {data.abonos.map(a => (
                        <tr key={a.id}>
                          <td style={{ fontSize: 12.5 }}>{String(a.fecha_pago).split("T")[0]}</td>
                          <td>{a.banco}</td>
                          <td style={{ fontSize: 12.5, color: "var(--muted)" }}>{a.num_operacion || "—"}</td>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 13 }}>${parseInt(a.monto_total).toLocaleString("es-CL")}</td>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 13, color: "var(--green)" }}>${parseInt(a.monto_aplicado).toLocaleString("es-CL")}</td>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 13, color: "var(--muted)" }}>
                            {parseInt(a.monto_total) - parseInt(a.monto_aplicado) > 0 ? `$${(parseInt(a.monto_total) - parseInt(a.monto_aplicado)).toLocaleString("es-CL")}` : "—"}
                          </td>
                          <td><button className="btn btn-danger btn-sm" onClick={() => revertirAbono(a)}><Ic.Trash /></button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="card-title">Historial de pagos</div>
              <div className="card">
                <div className="table-wrap">
                  <table>
                    <thead><tr><th>Fecha</th><th>Factura</th><th>Banco</th><th>Monto</th><th>Origen</th><th></th></tr></thead>
                    <tbody>
                      {data.pagos.length === 0 && (
                        <tr><td colSpan={6} style={{ textAlign: "center", color: "var(--muted)", padding: 16 }}>Sin pagos registrados</td></tr>
                      )}
                      {data.pagos.map(p => (
                        <tr key={p.id}>
                          <td style={{ fontSize: 12.5 }}>{String(p.fecha_pago).split("T")[0]}</td>
                          <td style={{ fontFamily: "var(--mono)" }}><FolioLink folio={p.factura_folio} facturaId={p.factura_id} tienePdf={p.tiene_pdf} addToast={addToast} /></td>
                          <td>{p.banco}</td>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 13 }}>${parseInt(p.monto_pagado).toLocaleString("es-CL")}</td>
                          <td style={{ fontSize: 12 }}>
                            {p.abono_id ? <span className="pill badge-blue">Abono #{p.abono_id}</span>
                              : p.banco === "Saldo a favor" ? <span className="pill badge-yellow">Saldo a favor</span>
                              : <span className="pill badge-green">Manual</span>}
                          </td>
                          <td><button className="btn btn-danger btn-sm" onClick={() => borrarPago(p)}><Ic.Trash /></button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {abonoForm && (
        <Modal title="Cargar abono" onClose={() => setAbonoForm(null)} onSave={guardarAbono} saving={saving} saveLabel="Aplicar abono">
          <div className="info-box" style={{ marginBottom: 16 }}>
            El monto se aplicará primero a la factura más atrasada con saldo pendiente, y el resto se irá descontando de las siguientes en orden.
          </div>
          <div className="grid-2">
            <Field label="Fecha de pago" value={abonoForm.fecha_pago} onChange={setA("fecha_pago")} type="date" />
            <Field label="Monto" value={abonoForm.monto} onChange={setA("monto")} type="number" placeholder="0" />
          </div>
          <div className="grid-2">
            <Field label="Banco" value={abonoForm.banco} onChange={setA("banco")} placeholder="Banco Estado" />
            <Field label="N° Operación" value={abonoForm.num_operacion} onChange={setA("num_operacion")} placeholder="Opcional" />
          </div>
          <div className="form-group">
            <label className="form-label">Observaciones</label>
            <textarea className="form-textarea" value={abonoForm.observaciones} onChange={e => setA("observaciones")(e.target.value)} />
          </div>
        </Modal>
      )}
    </div>
  );
}

/* ─── FACTURAS ───────────────────────────────────────────────────────────────── */
// Abre el PDF de una factura en una pestaña nueva (se abre antes del fetch para que el navegador no la bloquee)
async function abrirPdfFactura(id, addToast) {
  const w = window.open("", "_blank");
  try {
    const blob = await api.facturaPdf(id);
    const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
    if (w) w.location.href = url; else window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (w) w.close();
    addToast(e.message, "error");
  }
}

// Folio clicable que abre la factura (si tiene PDF); si no, texto plano
function FolioLink({ folio, facturaId, tienePdf, addToast }) {
  if (!folio) return "—";
  if (!tienePdf) return folio;
  return (
    <a href="#ver-factura" title="Ver factura (PDF)"
       onClick={e => { e.preventDefault(); abrirPdfFactura(facturaId, addToast); }}
       style={{ color: "var(--accent2)", textDecoration: "underline", cursor: "pointer" }}>{folio}</a>
  );
}

function Facturas({ addToast }) {
  const [list, setList] = useState([]);
  const [tab, setTab] = useState("all");
  const [emailModal, setEmailModal] = useState(null);
  const [emailTo, setEmailTo] = useState("");
  const [busy, setBusy] = useState({});
  const [pagoModal, setPagoModal] = useState(null);
  const [reporteMes,  setReporteMes]  = useState(new Date().getMonth() + 1);
  const [reporteAnio, setReporteAnio] = useState(new Date().getFullYear());
  const [descargando, setDescargando] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [busqueda, setBusqueda] = useState("");

  const descargarExcel = async () => {
    setDescargando(true);
    try {
      const blob = await api.reporteExcelMensual(reporteMes, reporteAnio);
      const meses = ["","Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `OptiWisp_Facturas_${meses[reporteMes]}_${reporteAnio}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch(e) { addToast(e.message, "error"); }
    setDescargando(false);
  };

  const load = useCallback(() => {
    const params = { limit: 5000, ...(tab !== "all" ? { estado: tab } : {}) };
    api.facturas(params).then(setList).catch(e => addToast(e.message, "error"));
  }, [tab, addToast]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { setPage(1); }, [tab, pageSize, busqueda]);

  const listFiltrada = list.filter(f => {
    if (!busqueda) return true;
    const q = busqueda.toLowerCase();
    return (f.folio||"").toString().toLowerCase().includes(q) ||
           (f.razon_social||"").toLowerCase().includes(q) ||
           (f.rut||"").toLowerCase().includes(q);
  });

  const totalPaginas = Math.max(1, Math.ceil(listFiltrada.length / pageSize));
  const paginaActual = Math.min(page, totalPaginas);
  const inicio = (paginaActual - 1) * pageSize;
  const listPagina = listFiltrada.slice(inicio, inicio + pageSize);

  const verificar = async f => {
    setBusy(p => ({ ...p, [f.id]: "verificar" }));
    try {
      const { estado } = await api.verificarDTE(f.id);
      addToast(`Factura ${f.folio}: ${estado}`, "success");
      load();
    } catch (e) { addToast(e.message, "error"); }
    setBusy(p => ({ ...p, [f.id]: null }));
  };

  const verPdf = async f => {
    setBusy(p => ({ ...p, [f.id]: "pdf" }));
    await abrirPdfFactura(f.id, addToast);
    setBusy(p => ({ ...p, [f.id]: null }));
  };

  const sendEmail = async () => {
    const emails = emailTo.split(",").map(e => e.trim()).filter(Boolean);
    try {
      await api.enviarEmail(emailModal.id, emails);
      addToast(`Enviado a ${emails.join(", ")}`, "success");
      setEmailModal(null); load();
    } catch (e) { addToast(e.message, "error"); }
  };

  const tabs = [["all","Todas"],["pendiente","Pendientes SII"],["aceptado","Aceptadas"],["rechazado","Rechazadas"],["error","Errores"]];

  return (
    <>
      <div className="topbar">
        <div><div className="topbar-title">Facturas emitidas</div><div className="topbar-sub">{listFiltrada.length} de {list.length} documentos</div></div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ position: "relative" }}>
            <input className="form-input" style={{ width: 220, paddingLeft: 32, fontSize: 13 }}
              placeholder="Buscar folio, cliente, RUT..." value={busqueda}
              onChange={e => setBusqueda(e.target.value)} />
            <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "var(--muted)" }}>🔍</span>
          </div>
          <select className="form-select" style={{ width: 130, padding: "7px 12px", fontSize: 13 }}
            value={reporteMes} onChange={e => setReporteMes(parseInt(e.target.value))}>
            {["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]
              .map((m,i) => <option key={i+1} value={i+1}>{m}</option>)}
          </select>
          <select className="form-select" style={{ width: 90, padding: "7px 12px", fontSize: 13 }}
            value={reporteAnio} onChange={e => setReporteAnio(parseInt(e.target.value))}>
            {[2024,2025,2026,2027].map(a => <option key={a} value={a}>{a}</option>)}
          </select>
          <select className="form-select" style={{ width: 130, padding: "7px 12px", fontSize: 13 }}
            value={pageSize} onChange={e => setPageSize(parseInt(e.target.value))} title="Facturas por página">
            {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n} por página</option>)}
            <option value={999999}>Ver todos</option>
          </select>
          <button className="btn btn-success btn-sm" onClick={descargarExcel} disabled={descargando}>
            <Ic.Download />{descargando ? "Generando..." : "Excel"}
          </button>
        </div>
      </div>
      <div className="content">
        <div className="tabs">
          {tabs.map(([k,l]) => <button key={k} className={`tab${tab===k?" active":""}`} onClick={() => setTab(k)}>{l}</button>)}
        </div>
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead><tr><th>Folio</th><th>Cliente</th><th>Fecha</th><th>Monto Total</th><th>Estado SII</th><th>Estado Pago</th><th>Email</th><th>Acciones</th></tr></thead>
              <tbody>
                {listPagina.map(f => (
                  <tr key={f.id}>
                    <td style={{ fontFamily: "var(--mono)", fontWeight: 600 }}>{f.folio || "—"}</td>
                    <td>{f.razon_social}</td>
                    <td style={{ fontFamily: "var(--mono)", fontSize: 12 }}>{String(f.fecha_emision).split("T")[0]}</td>
                    <td style={{ fontFamily: "var(--mono)" }}>${parseInt(f.monto_total).toLocaleString("es-CL")}</td>
                    <td><StatusPill status={f.estado} /></td>
                    <td><StatusPill status={f.estado_pago || "sin_pago"} /></td>
                    <td>{f.email_enviado ? <span style={{ color: "var(--green)", fontSize: 12 }}>✓ Enviado</span> : <span style={{ color: "var(--muted)", fontSize: 12 }}>Pendiente</span>}</td>
                    <td>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button className="btn btn-secondary btn-sm" onClick={() => verPdf(f)} disabled={!f.tiene_pdf || !!busy[f.id]} title={f.tiene_pdf ? "Ver PDF" : "PDF no disponible"}>
                          {busy[f.id] === "pdf" ? "…" : <Ic.Eye />}
                        </button>
                        <button className="btn btn-success btn-sm" onClick={() => setPagoModal(f)} title="Registrar pago">
                          <Ic.Cash />
                        </button>
                        <button className="btn btn-secondary btn-sm" onClick={() => verificar(f)} disabled={!!busy[f.id]} title="Verificar estado SII">
                          {busy[f.id] === "verificar" ? "…" : <Ic.Spin />}
                        </button>
                        {f.estado === "aceptado" && (
                          <button className="btn btn-secondary btn-sm" onClick={() => { setEmailModal(f); setEmailTo((f.emails || []).join(", ")); }} title="Enviar por correo">
                            <Ic.Mail />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
                {listFiltrada.length === 0 && <tr><td colSpan={7} style={{ textAlign: "center", color: "var(--muted)", padding: 32 }}>{busqueda ? "Sin resultados para la búsqueda" : "Sin facturas en esta categoría"}</td></tr>}
              </tbody>
            </table>
          </div>
          {listFiltrada.length > 0 && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 4px 4px" }}>
              <span style={{ fontSize: 12.5, color: "var(--muted)" }}>
                Mostrando {inicio + 1}–{Math.min(inicio + pageSize, listFiltrada.length)} de {listFiltrada.length}
              </span>
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(1)} disabled={paginaActual === 1}>«</button>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={paginaActual === 1}>‹ Anterior</button>
                <span style={{ fontSize: 13, padding: "0 8px", color: "var(--text)" }}>Página {paginaActual} de {totalPaginas}</span>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(p => Math.min(totalPaginas, p + 1))} disabled={paginaActual === totalPaginas}>Siguiente ›</button>
                <button className="btn btn-secondary btn-sm" onClick={() => setPage(totalPaginas)} disabled={paginaActual === totalPaginas}>»</button>
              </div>
            </div>
          )}
        </div>
      </div>

      {pagoModal && (
        <PagoModal
          factura={pagoModal}
          cliente={{ razon_social: pagoModal.razon_social }}
          onClose={() => setPagoModal(null)}
          onSaved={load}
          addToast={addToast}
        />
      )}

      {emailModal && (
        <Modal title={`Enviar factura ${emailModal.folio}`} onClose={() => setEmailModal(null)} onSave={sendEmail} saveLabel="Enviar">
          <p style={{ fontSize: 13, color: "var(--muted)", marginBottom: 16 }}>La factura PDF se enviará a los correos indicados.</p>
          <Field label="Destinatarios (separados por coma)" value={emailTo} onChange={setEmailTo} />
        </Modal>
      )}
    </>
  );
}

/* ─── PROGRAMAR ──────────────────────────────────────────────────────────────── */
function Programar({ uf, addToast }) {
  const [clientes, setClientes] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const hoy = new Date();

  useEffect(() => {
    api.clientes().then(data => setClientes(data.filter(c => c.activo))).catch(e => addToast(e.message, "error"));
  }, [addToast]);

  const todayClients = clientes.filter(c => c.dia_facturacion === hoy.getDate());
  const toggle = id => setSelected(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]);
  const allSelected = selected.length === clientes.length && clientes.length > 0;
  const toggleAll = () => setSelected(allSelected ? [] : clientes.map(c => c.id));

  const emitir = async () => {
    setConfirm(false);
    setLoading(true);
    try {
      const result = await api.emitirFacturas({ clienteIds: selected });
      addToast(`${result.emitidas} factura(s) emitidas, ${result.errores} errores`, result.errores > 0 ? "warning" : "success");
      setSelected([]);
    } catch (e) { addToast(e.message, "error"); }
    setLoading(false);
  };

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Programación de facturas</div>
          <div className="topbar-sub">{hoy.toLocaleDateString("es-CL", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</div>
        </div>
        {selected.length > 0 && (
          <button className="btn btn-primary" onClick={() => setConfirm(true)} disabled={loading}>
            <Ic.Send />{loading ? "Emitiendo..." : `Emitir ${selected.length} factura(s)`}
          </button>
        )}
      </div>
      <div className="content">
        {todayClients.length > 0 && (
          <div className="uf-banner" style={{ background: "rgba(245,158,11,.08)", borderColor: "rgba(245,158,11,.25)", marginBottom: 22 }}>
            <span style={{ fontSize: 20 }}>📅</span>
            <div>
              <div style={{ fontWeight: 600 }}>Hoy corresponde facturar a {todayClients.length} cliente(s)</div>
              <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 3 }}>{todayClients.map(c => c.razon_social).join(", ")}</div>
            </div>
            <button className="btn btn-sm" style={{ marginLeft: "auto", background: "rgba(245,158,11,.2)", color: "var(--yellow)", border: "1px solid rgba(245,158,11,.3)" }}
              onClick={() => setSelected(todayClients.map(c => c.id))}>
              Seleccionar del día
            </button>
          </div>
        )}

        {uf && (
          <div style={{ marginBottom: 16, fontSize: 13, color: "var(--muted)" }}>
            UF usada para conversión: <strong style={{ color: "var(--accent)", fontFamily: "var(--mono)" }}>${parseFloat(uf.valor).toLocaleString("es-CL")}</strong> ({uf.fecha})
          </div>
        )}

        <div className="card">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <div className="card-title" style={{ margin: 0 }}>Clientes activos</div>
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, cursor: "pointer", color: "var(--muted)" }}>
              <input type="checkbox" checked={allSelected} onChange={toggleAll} /> Seleccionar todos
            </label>
          </div>
          <div className="table-wrap">
            <table>
              <thead><tr><th style={{ width: 40 }}></th><th>Cliente</th><th>RUT</th><th>Moneda</th><th>Monto a facturar</th><th>Día facturación</th><th>Correos</th></tr></thead>
              <tbody>
                {clientes.map(c => {
                  const montoClp = c.moneda === "UF" && uf ? Math.round(parseFloat(c.monto) * parseFloat(uf.valor)) : parseFloat(c.monto);
                  const esHoy = c.dia_facturacion === hoy.getDate();
                  return (
                    <tr key={c.id} style={esHoy ? { background: "rgba(245,158,11,.04)" } : {}}>
                      <td><input type="checkbox" checked={selected.includes(c.id)} onChange={() => toggle(c.id)} /></td>
                      <td>
                        <span style={{ fontWeight: 600 }}>{c.razon_social}</span>
                        {esHoy && <span className="pill badge-yellow" style={{ marginLeft: 8, fontSize: 10 }}>Hoy</span>}
                      </td>
                      <td style={{ fontFamily: "var(--mono)", fontSize: 12 }}>{c.rut}</td>
                      <td><span className={`pill ${c.moneda === "UF" ? "badge-blue" : "badge-green"}`}>{c.moneda}</span></td>
                      <td style={{ fontFamily: "var(--mono)", fontSize: 13 }}>
                        {c.moneda === "UF"
                          ? <>{c.monto} UF {uf ? <span style={{ color: "var(--muted)", fontSize: 11 }}>= ${montoClp.toLocaleString("es-CL")}</span> : null}</>
                          : <>${montoClp.toLocaleString("es-CL")} <span style={{ background: "rgba(34,197,94,.12)", color: "var(--green)", fontSize: 10, fontWeight: 700, padding: "1px 6px", borderRadius: 10, marginLeft: 4, fontFamily: "var(--font)" }}>CLP</span></>}
                      </td>
                      <td style={{ textAlign: "center" }}>Día {c.dia_facturacion}</td>
                      <td style={{ fontSize: 12, color: "var(--muted)" }}>{(c.emails || []).join(", ")}</td>
                    </tr>
                  );
                })}
                {clientes.length === 0 && <tr><td colSpan={7} style={{ textAlign: "center", color: "var(--muted)", padding: 28 }}>No hay clientes activos</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {confirm && (
        <Modal title="Confirmar emisión" onClose={() => setConfirm(false)} onSave={emitir} saveLabel="Confirmar y emitir" saving={loading}>
          <p style={{ fontSize: 13.5, marginBottom: 14 }}>Se emitirán <strong>{selected.length} factura(s)</strong> via API OpenFactura para:</p>
          <ul style={{ paddingLeft: 18, fontSize: 13, color: "var(--muted)", lineHeight: 2 }}>
            {clientes.filter(c => selected.includes(c.id)).map(c => {
              const clp = c.moneda === "UF" && uf ? Math.round(parseFloat(c.monto) * parseFloat(uf.valor)) : parseFloat(c.monto);
              return <li key={c.id}>{c.razon_social} — ${clp.toLocaleString("es-CL")} CLP</li>;
            })}
          </ul>
          <div className="info-box" style={{ marginTop: 14 }}>
            El cron también ejecuta esto automáticamente según el horario configurado.
          </div>
        </Modal>
      )}
    </>
  );
}

/* ─── PAGOS MODAL ────────────────────────────────────────────────────────── */
function PagoModal({ factura, cliente, onClose, onSaved, addToast }) {
  const [pagos, setPagos] = useState([]);
  const [form, setForm] = useState({
    fecha_pago: new Date().toISOString().split("T")[0],
    banco: "Santander",
    num_operacion: "",
    monto_pagado: factura.monto_total,
    observaciones: ""
  });
  const [saving, setSaving] = useState(false);
  const set = k => v => setForm(p => ({ ...p, [k]: v }));

  useEffect(() => {
    api.pagos(factura.id).then(setPagos).catch(e => addToast(e.message, "error"));
  }, [factura.id, addToast]);

  const totalPagado = pagos.reduce((s, p) => s + parseInt(p.monto_pagado), 0);
  const pendiente   = parseInt(factura.monto_total) - totalPagado;

  const save = async () => {
    setSaving(true);
    try {
      await api.registrarPago({ ...form, factura_id: factura.id, monto_pagado: parseInt(form.monto_pagado) });
      addToast("Pago registrado correctamente", "success");
      onSaved();
      onClose();
    } catch(e) { addToast(e.message, "error"); }
    setSaving(false);
  };

  const del = async (id) => {
    try {
      await api.eliminarPago(id);
      api.pagos(factura.id).then(setPagos);
      addToast("Pago eliminado", "info");
      onSaved();
    } catch(e) { addToast(e.message, "error"); }
  };

  return (
    <Modal title={`Pagos — Factura ${factura.folio}`} onClose={onClose} onSave={save} saveLabel="Registrar pago" saving={saving}>
      {/* Resumen */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 20 }}>
        <div style={{ background: "var(--surface2)", borderRadius: 8, padding: "12px 16px", textAlign: "center" }}>
          <div style={{ fontSize: 11, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".06em" }}>Total factura</div>
          <div style={{ fontSize: 16, fontWeight: 700, fontFamily: "var(--mono)", marginTop: 4 }}>${parseInt(factura.monto_total).toLocaleString("es-CL")}</div>
        </div>
        <div style={{ background: "rgba(34,197,94,.08)", border: "1px solid rgba(34,197,94,.2)", borderRadius: 8, padding: "12px 16px", textAlign: "center" }}>
          <div style={{ fontSize: 11, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".06em" }}>Pagado</div>
          <div style={{ fontSize: 16, fontWeight: 700, fontFamily: "var(--mono)", color: "var(--green)", marginTop: 4 }}>${totalPagado.toLocaleString("es-CL")}</div>
        </div>
        <div style={{ background: pendiente > 0 ? "rgba(239,68,68,.08)" : "rgba(34,197,94,.08)", border: `1px solid ${pendiente > 0 ? "rgba(239,68,68,.2)" : "rgba(34,197,94,.2)"}`, borderRadius: 8, padding: "12px 16px", textAlign: "center" }}>
          <div style={{ fontSize: 11, color: "var(--muted)", textTransform: "uppercase", letterSpacing: ".06em" }}>Pendiente</div>
          <div style={{ fontSize: 16, fontWeight: 700, fontFamily: "var(--mono)", color: pendiente > 0 ? "var(--red)" : "var(--green)", marginTop: 4 }}>${pendiente.toLocaleString("es-CL")}</div>
        </div>
      </div>

      {/* Pagos registrados */}
      {pagos.length > 0 && (
        <div style={{ marginBottom: 20 }}>
          <div className="card-title">Pagos registrados</div>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5 }}>
            <thead><tr>
              <th style={{ textAlign: "left", padding: "6px 8px", color: "var(--muted)", fontSize: 11 }}>Fecha</th>
              <th style={{ textAlign: "left", padding: "6px 8px", color: "var(--muted)", fontSize: 11 }}>Banco</th>
              <th style={{ textAlign: "left", padding: "6px 8px", color: "var(--muted)", fontSize: 11 }}>N° Op.</th>
              <th style={{ textAlign: "right", padding: "6px 8px", color: "var(--muted)", fontSize: 11 }}>Monto</th>
              <th></th>
            </tr></thead>
            <tbody>
              {pagos.map(p => (
                <tr key={p.id} style={{ borderTop: "1px solid var(--border)" }}>
                  <td style={{ padding: "8px", fontFamily: "var(--mono)", fontSize: 12 }}>{p.fecha_pago}</td>
                  <td style={{ padding: "8px" }}>{p.banco}</td>
                  <td style={{ padding: "8px", fontFamily: "var(--mono)", fontSize: 12 }}>{p.num_operacion || "—"}</td>
                  <td style={{ padding: "8px", textAlign: "right", fontFamily: "var(--mono)", color: "var(--green)", fontWeight: 600 }}>${parseInt(p.monto_pagado).toLocaleString("es-CL")}</td>
                  <td style={{ padding: "8px" }}><button className="btn btn-danger btn-sm" onClick={() => del(p.id)}><Ic.Trash /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <hr className="divider" />
      <div className="card-title">Registrar nuevo pago</div>

      <div className="grid-2">
        <Field label="Fecha de pago" value={form.fecha_pago} onChange={set("fecha_pago")} type="date" />
        <div className="form-group">
          <label className="form-label">Banco</label>
          <select className="form-select" value={form.banco} onChange={e => set("banco")(e.target.value)}>
            <option>Santander</option>
            <option>BancoEstado</option>
            <option>BCI</option>
            <option>Chile</option>
            <option>Scotiabank</option>
            <option>Itaú</option>
            <option>Security</option>
            <option>Otro</option>
          </select>
        </div>
      </div>
      <div className="grid-2">
        <Field label="N° Operación / Transferencia" value={form.num_operacion} onChange={set("num_operacion")} placeholder="123456789" />
        <Field label="Monto pagado (CLP)" value={form.monto_pagado} onChange={set("monto_pagado")} type="number" />
      </div>
      <Field label="Observaciones" value={form.observaciones} onChange={set("observaciones")} placeholder="Pago parcial, abono, etc." />
    </Modal>
  );
}

/* ─── LOGS ───────────────────────────────────────────────────────────────── */
function Logs({ addToast }) {
  const [cronLogs, setCronLogs] = useState([]);
  const [errores, setErrores] = useState([]);
  const [tab, setTab] = useState("cron");

  useEffect(() => {
    api.logs().then(setCronLogs).catch(e => addToast(e.message, "error"));
    api.logsFacturas().then(setErrores).catch(e => addToast(e.message, "error"));
  }, [addToast]);

  return (
    <>
      <div className="topbar">
        <div><div className="topbar-title">Logs del sistema</div><div className="topbar-sub">Historial de ejecuciones y errores</div></div>
        <button className="btn btn-secondary btn-sm" onClick={() => {
          api.logs().then(setCronLogs).catch(e => addToast(e.message, "error"));
          api.logsFacturas().then(setErrores).catch(e => addToast(e.message, "error"));
          addToast("Logs actualizados", "info");
        }}><Ic.Spin />Actualizar</button>
      </div>
      <div className="content">
        <div className="tabs">
          <button className={`tab${tab === "cron" ? " active" : ""}`} onClick={() => setTab("cron")}>
            Ejecuciones del cron ({cronLogs.length})
          </button>
          <button className={`tab${tab === "errores" ? " active" : ""}`} onClick={() => setTab("errores")}>
            Facturas con error ({errores.length})
          </button>
        </div>

        {tab === "cron" && (
          <div className="card">
            <div className="table-wrap">
              <table>
                <thead><tr><th>Fecha/Hora</th><th>Clientes</th><th>Emitidas OK</th><th>Errores</th><th>Detalle</th></tr></thead>
                <tbody>
                  {cronLogs.length === 0 && (
                    <tr><td colSpan={5} style={{ textAlign: "center", color: "var(--muted)", padding: 32 }}>Sin ejecuciones registradas</td></tr>
                  )}
                  {cronLogs.map(log => {
                    const detalle = log.detalle || [];
                    return (
                      <tr key={log.id}>
                        <td style={{ fontFamily: "var(--mono)", fontSize: 12 }}>{new Date(log.ejecutado_at).toLocaleString("es-CL")}</td>
                        <td style={{ textAlign: "center" }}>{log.clientes_count}</td>
                        <td style={{ textAlign: "center" }}>
                          <span style={{ color: "var(--green)", fontWeight: 600 }}>{log.facturas_ok}</span>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <span style={{ color: log.facturas_error > 0 ? "var(--red)" : "var(--muted)", fontWeight: log.facturas_error > 0 ? 600 : 400 }}>{log.facturas_error}</span>
                        </td>
                        <td style={{ fontSize: 12, color: "var(--muted)" }}>
                          {detalle.map((d, i) => (
                            <span key={i} style={{ marginRight: 8 }}>
                              {d.estado === "ok"
                                ? <span style={{ color: "var(--green)" }}>✓ {d.razonSocial?.split(" ")[0]} ({d.folio})</span>
                                : <span style={{ color: "var(--red)" }}>✗ {d.razonSocial?.split(" ")[0]}: {d.error}</span>
                              }
                            </span>
                          ))}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {tab === "errores" && (
          <div className="card">
            {errores.length === 0
              ? <p style={{ color: "var(--green)", fontSize: 13, textAlign: "center", padding: 32 }}>✓ Sin facturas con error</p>
              : <div className="table-wrap">
                  <table>
                    <thead><tr><th>Fecha</th><th>Cliente</th><th>RUT</th><th>Folio</th><th>Estado</th><th>Error</th></tr></thead>
                    <tbody>
                      {errores.map(f => (
                        <tr key={f.id}>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 12 }}>{String(f.fecha_emision).split("T")[0]}</td>
                          <td style={{ fontSize: 13 }}>{f.razon_social}</td>
                          <td style={{ fontFamily: "var(--mono)", fontSize: 12 }}>{f.rut}</td>
                          <td style={{ fontFamily: "var(--mono)" }}>{f.folio || "—"}</td>
                          <td><StatusPill status={f.estado} /></td>
                          <td style={{ fontSize: 12, color: "var(--red)", maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{f.error_msg || "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
            }
          </div>
        )}
      </div>
    </>
  );
}

/* ─── CONFIGURACIÓN ──────────────────────────────────────────────────────────── */
function Configuracion({ addToast }) {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const set = k => v => setForm(p => ({ ...p, [k]: v }));

  useEffect(() => {
    api.getConfig().then(setForm).catch(e => addToast(e.message, "error"));
  }, [addToast]);

  const save = async () => {
    setSaving(true);
    try { await api.saveConfig(form); addToast("Configuración guardada", "success"); }
    catch (e) { addToast(e.message, "error"); }
    setSaving(false);
  };

  return (
    <>
      <div className="topbar">
        <div><div className="topbar-title">Configuración</div><div className="topbar-sub">API Key, emisor y SMTP</div></div>
        <button className="btn btn-primary btn-sm" onClick={save} disabled={saving}><Ic.Check />{saving ? "Guardando…" : "Guardar cambios"}</button>
      </div>
      <div className="content">
        <div className="grid-2" style={{ gap: 20 }}>
          {/* OpenFactura */}
          <div className="card">
            <div className="card-title">OpenFactura API</div>
            <div className="form-group">
              <label className="form-label">URL del API</label>
              <select className="form-select" value={form.openfactura_api_url || ""} onChange={e => set("openfactura_api_url")(e.target.value)}>
                <option value="https://dev-api.haulmer.com">Demo/Dev — dev-api.haulmer.com</option>
                <option value="https://api.haulmer.com">Producción — api.haulmer.com</option>
              </select>
            </div>
            <Field label="API Key (dejar en blanco para no modificar)" value={form.openfactura_api_key || ""} onChange={set("openfactura_api_key")} placeholder="••••••••" type="password" />
            <div className="info-box">
              Genera tu API Key en OpenFactura → Configuración → Módulo API → Generar API Key.
              Tu empresa debe haber completado la certificación SII.
            </div>
          </div>

          {/* Emisor */}
          <div className="card">
            <div className="card-title">Datos del emisor</div>
            <div className="grid-2">
              <Field label="RUT Emisor" value={form.emisor_rut || ""} onChange={set("emisor_rut")} placeholder="76795561-8" />
              <Field label="Razón Social" value={form.emisor_nombre || ""} onChange={set("emisor_nombre")} />
            </div>
            <Field label="Giro" value={form.emisor_giro || ""} onChange={set("emisor_giro")} />
            <div className="grid-2">
              <Field label="Dirección" value={form.emisor_dir || ""} onChange={set("emisor_dir")} />
              <Field label="Comuna" value={form.emisor_comuna || ""} onChange={set("emisor_comuna")} />
            </div>
            <div className="grid-2">
              <Field label="Cód. Actividad Económica" value={form.emisor_acteco || ""} onChange={set("emisor_acteco")} placeholder="525130" />
              <Field label="Cód. Sucursal SII" value={form.emisor_sucursal || ""} onChange={set("emisor_sucursal")} placeholder="81303347" />
            </div>
          </div>

          {/* SMTP */}
          <div className="card">
            <div className="card-title">Configuración de correo (SMTP)</div>
            <div className="grid-2">
              <Field label="Host SMTP" value={form.smtp_host || ""} onChange={set("smtp_host")} placeholder="smtp.gmail.com" />
              <Field label="Puerto" value={form.smtp_port || 587} onChange={set("smtp_port")} type="number" />
            </div>
            <Field label="Usuario" value={form.smtp_user || ""} onChange={set("smtp_user")} placeholder="correo@gmail.com" />
            <Field label="Contraseña / App Password (dejar en blanco para no modificar)" value={form.smtp_pass || ""} onChange={set("smtp_pass")} type="password" placeholder="••••••••" />
            <Field label="Correo remitente (From)" value={form.smtp_from || ""} onChange={set("smtp_from")} placeholder="Facturación <fac@empresa.cl>" />
            <div className="switch-row">
              <div><div className="switch-label">Envío automático al aceptar SII</div><div className="switch-sub">Envía el PDF automáticamente tras validación</div></div>
              <label className="switch"><input type="checkbox" checked={!!form.auto_envio_email} onChange={e => set("auto_envio_email")(e.target.checked)}/><span className="slider"/></label>
            </div>
          </div>

          {/* Cron */}
          <div className="card">
            <div className="card-title">Programación automática (Cron)</div>
            <Field label="Horario cron (formato Unix)" value={form.cron_schedule || "0 8 * * *"} onChange={set("cron_schedule")} placeholder="0 8 * * *" />
            <div style={{ fontSize: 12.5, color: "var(--muted)", lineHeight: 2, marginTop: 8 }}>
              <strong style={{ color: "var(--text)" }}>Ejemplos:</strong><br/>
              <code style={{ color: "var(--accent)", fontFamily: "var(--mono)" }}>0 8 * * *</code> → Todos los días a las 08:00<br/>
              <code style={{ color: "var(--accent)", fontFamily: "var(--mono)" }}>0 9 * * 1-5</code> → Lun–Vie a las 09:00<br/>
              <code style={{ color: "var(--accent)", fontFamily: "var(--mono)" }}>0 8 1 * *</code> → El día 1 de cada mes<br/>
              Zona horaria: <strong>America/Santiago</strong>
            </div>
            <hr className="divider" />
            <div style={{ fontSize: 12.5, color: "var(--muted)", lineHeight: 1.8 }}>
              <strong style={{ color: "var(--text)" }}>Endpoints API:</strong><br/>
              <span style={{ fontFamily: "var(--mono)", color: "var(--accent)" }}>POST /v2/dte/document</span> — Emitir DTE<br/>
              <span style={{ fontFamily: "var(--mono)", color: "var(--green)" }}>GET /v2/dte/document/:folio</span> — Estado SII<br/>
              <span style={{ fontFamily: "var(--mono)", color: "var(--accent)" }}>POST /v2/dte/email</span> — Reenviar correo
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

/* ─── USUARIOS ───────────────────────────────────────────────────────────────── */
function Usuarios({ addToast, currentUser }) {
  const [list, setList] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  const load = useCallback(() => api.usuarios().then(setList).catch(e => addToast(e.message, "error")), [addToast]);
  useEffect(() => { load(); }, [load]);

  const set = k => v => setForm(p => ({ ...p, [k]: v }));

  const openNew = () => { setForm({ email: "", nombre: "", rol: "operador", activo: true, password: "" }); setModal("new"); };
  const openEdit = u => { setForm({ ...u, password: "" }); setModal(u); };

  const save = async () => {
    if (modal === "new" && (!form.password || form.password.length < 8)) {
      addToast("La contraseña debe tener al menos 8 caracteres", "error");
      return;
    }
    if (form.password && form.password.length < 8) {
      addToast("La contraseña debe tener al menos 8 caracteres", "error");
      return;
    }
    setSaving(true);
    try {
      const body = { email: form.email, nombre: form.nombre, rol: form.rol, activo: form.activo };
      if (form.password) body.password = form.password;
      if (modal === "new") { await api.usuarioCreate(body); addToast("Usuario creado", "success"); }
      else { await api.usuarioUpdate(modal.id, body); addToast("Usuario actualizado", "success"); }
      setModal(null); load();
    } catch (e) { addToast(e.message, "error"); }
    setSaving(false);
  };

  const del = async u => {
    if (!window.confirm(`¿Eliminar a ${u.nombre}?`)) return;
    try { await api.usuarioDelete(u.id); addToast("Usuario eliminado", "info"); load(); }
    catch (e) { addToast(e.message, "error"); }
  };

  return (
    <>
      <div className="topbar">
        <div><div className="topbar-title">Usuarios</div><div className="topbar-sub">{list.length} cuentas con acceso al sistema</div></div>
        <button className="btn btn-primary btn-sm" onClick={openNew}><Ic.Plus />Nuevo usuario</button>
      </div>
      <div className="content">
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead><tr><th>Nombre</th><th>Correo</th><th>Rol</th><th>Estado</th><th>Creado</th><th></th></tr></thead>
              <tbody>
                {list.map(u => (
                  <tr key={u.id}>
                    <td style={{ fontWeight: 600 }}>{u.nombre}{u.id === currentUser?.id ? <span style={{ marginLeft: 8, fontSize: 11, color: "var(--accent)", background: "rgba(14,165,233,.1)", padding: "2px 8px", borderRadius: 10, fontWeight: 600 }}>Tú</span> : null}</td>
                    <td style={{ fontSize: 13 }}>{u.email}</td>
                    <td><span className={`pill ${u.rol === "admin" ? "badge-blue" : "badge-green"}`}>{u.rol === "admin" ? "Administrador" : "Operador"}</span></td>
                    <td><StatusPill status={u.activo ? "activo" : "inactivo"} /></td>
                    <td style={{ fontSize: 12, color: "var(--muted)" }}>{new Date(u.created_at).toLocaleDateString("es-CL")}</td>
                    <td>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button className="btn btn-secondary btn-sm" onClick={() => openEdit(u)}><Ic.Edit /></button>
                        <button className="btn btn-danger btn-sm" onClick={() => del(u)} disabled={u.id === currentUser?.id} title={u.id === currentUser?.id ? "No puedes eliminar tu propia cuenta" : "Eliminar"}><Ic.Trash /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {modal && (
        <Modal title={modal === "new" ? "Nuevo usuario" : "Editar usuario"} onClose={() => setModal(null)} onSave={save} saving={saving}>
          <div className="grid-2">
            <Field label="Nombre" value={form.nombre} onChange={set("nombre")} />
            <Field label="Correo" value={form.email} onChange={set("email")} placeholder="usuario@optiwisp.cl" />
          </div>
          <div className="grid-2">
            <div className="form-group">
              <label className="form-label">Rol</label>
              <select className="form-select" value={form.rol} onChange={e => set("rol")(e.target.value)}>
                <option value="operador">Operador</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
            <Field label={modal === "new" ? "Contraseña" : "Nueva contraseña (dejar en blanco para no modificar)"}
              value={form.password} onChange={set("password")} type="password" placeholder="••••••••" />
          </div>
          <div className="switch-row">
            <div><div className="switch-label">Usuario activo</div><div className="switch-sub">Puede iniciar sesión en el sistema</div></div>
            <label className="switch">
              <input type="checkbox" checked={!!form.activo} disabled={modal !== "new" && modal.id === currentUser?.id}
                onChange={e => set("activo")(e.target.checked)}/><span className="slider"/>
            </label>
          </div>
        </Modal>
      )}
    </>
  );
}
